import React, { type FC, useState } from "react";
import { useApiCall } from "../api/api";
import { Project } from "../api/dto";
import type { InspectionPhoto } from "../api/dto/InspectionPhoto";
import type { Question } from "../api/dto/Question";
import { Input } from "../components/form/Input";
import { Select } from "../components/form/Select";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

const NO_QUESTION = "-";

export const EditPhotoDescription: FC<{
  photo: InspectionPhoto;
  questions?: Question[];
  onFinished?: (photo: InspectionPhoto) => void;
}> = (props) => {
  const { updatePhoto } = useApiCall();
  const [name, setName] = useState(props.photo.description);
  const [questionId, setQuestionId] = useState(props.photo.questionId ?? NO_QUESTION);

  const questionOptions = Object.fromEntries([
    [NO_QUESTION, "Geen vraag"],
    ...(props.questions ?? [])
      .filter((q) => !!q.number)
      .sort((a, b) => a.number.padStart(3, "0").localeCompare(b.number.padStart(3, "0")))
      .map((q) => [q.id, `Vraag ${q.number}`]),
  ]);

  const save = async () => {
    const resolvedQuestionId = questionId === NO_QUESTION ? null : questionId;
    await updatePhoto(
      props.photo.inspectionId,
      props.photo.id,
      props.photo.rotation,
      name,
      resolvedQuestionId,
    );
    props.onFinished?.({ ...props.photo, description: name, questionId: resolvedQuestionId });
  };
  return (
    <div>
      <Input type={"text"} label={"Toelichting"} value={name} onChange={setName} />
      {props.questions && (
        <Select
          label={"Vraag"}
          options={questionOptions}
          value={questionId}
          onChange={setQuestionId}
        />
      )}
      <ModalFooter text={"Opslaan"} onSubmit={save} />
    </div>
  );
};
